export default __webpack_public_path__ + "static/media/ci6.0c3f813c.png";